import axios from "axios";

const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
});

apiInstance.setHeaders = (headers) => {
  Object.assign(apiInstance.defaults.headers, headers);
};

let handleUnauthorized = null;

export const setUnauthorizedHandler = (callback) => {
  handleUnauthorized = callback;
};

apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.error("Unauthorized - redirect to login");
          if (handleUnauthorized) handleUnauthorized();
          window.location.href = "/";
          break;
        case 403:
          console.error("Forbidden - redirect to login");
          if (handleUnauthorized) handleUnauthorized();
          window.location.href = "/";
          break;
        case 404:
          console.error("Not found");
          break;
        case 500:
          console.error("Server error");
          break;
        default:
          console.error("Unhandled error status:", error.response.status);
      }
    } else {
      console.error("Unknown error:", error);
      // window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default apiInstance;
